import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.prototype.$textRight = ($text_before, $text, $length) => {
  var $left_len = $text_before.length;
  var $text_len = $text.length;

  var $len = $left_len + $text_len;

  var $space = "";
  for (var $i = 0; $i < $length - $len; $i++) {
    $space += " ";
  }
  return $text_before + $space + $text;
}

Vue.prototype.$textCenter = ($text_before, $text, $length) => {
  var $mid = $length / 2;
  var $char_len = $text.length / 2;

  var $start = $mid - $char_len;

  var $space = "";
  for (var $i = 0; $i < $start; $i++) {
    $space += " ";
  }

  return $space + $text;
}

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js